import { useState } from 'react';
import type { AssetType } from '@/types/assets';

export function useAddAssetState(initialAssetType: AssetType) {
  const [selectedAssetType, setSelectedAssetType] = useState<AssetType>(initialAssetType);
  const [equitySource, setEquitySource] = useState<'stock' | 'fund'>('stock');
  const [searchQuery, setSearchQuery] = useState<string>('');

  return {
    selectedAssetType,
    equitySource,
    searchQuery,
    setSelectedAssetType,
    setEquitySource,
    setSearchQuery,
  };
}
